export const showElement = (element) => {
    if (element.classList.contains("d-none")) {
        element.classList.remove("d-none");
    }
};
export const hideElement = (element) => {
    if (!element.classList.contains("d-none")) {
        element.classList.add("d-none");
    }
};
